<template>
    <div class="modal-content">
        <slot />
    </div>
</template>

<script>
export default {

    name: 'ModalContent'

};
</script>
